import styled from '@emotion/styled';

export const List = styled.ul`
  width: 758px;
  color: #37474f;
`;
export const Item = styled.li`
  background: #ffffff;
  box-shadow: 0px 2px 16px rgba(0, 0, 0, 0.04);
  border-radius: 12px;
  margin-bottom: 10px;
  padding: 15px;
`;
